import React from "react";
import {connect} from "react-redux";
import actionTypes from "../../../store/actionTypes";
import {IStore} from "../../../store/reducers";
import {
    Bar,
    BarChart,
    CartesianGrid,
    Cell,
    ResponsiveContainer,
    XAxis,
    YAxis,
    LineChart,
    Line,
    Tooltip,
    Brush
} from "recharts";
import {Paper, Typography} from "@material-ui/core";
import {IParcela} from "../../../types";
import {resolucion_tablet} from "../../../tools/resolucion";

const config = require('../../../config.json');
const texts = require('../../../texts/riegoneto.json')


interface IProps {
    setHistorico(historico: Record<string, Record<string, number>>): void
    historico: Record<string, Record<string, number>>
    parcela: string
    parcelaProps: IParcela
    idioma: string
}

interface Istate {
    vertical: boolean
    cambiando: boolean
    text: Record<string, string>
}

class Historico extends React.Component<IProps, Istate> {
    state: Istate = {
        vertical: window.matchMedia("(orientation: portrait)").matches,
        cambiando: false,
        text: texts[this.props.idioma]
    };

    shouldComponentUpdate(nextProps: Readonly<IProps>, nextState: Readonly<Istate>, nextContext: any): boolean {
        if (this.props.idioma !== nextProps.idioma) {
            this.setState({
                text: texts[nextProps.idioma]
            })
        }
        return true
    }

    render() {
        const doOnOrientationChange = () => {
            if (!this.state.cambiando) {
                this.setState({cambiando: true, vertical: !this.state.vertical})
                setTimeout(() => this.setState({cambiando: false}), 100)
            }
        }

        window.addEventListener("orientationchange", function() {
            doOnOrientationChange()
        }, false);

        const data = []
        for (let key of Object.keys(this.props.historico)) {
            data.push({
                name: parseInt(key.split('_')[2]) + '/' + parseInt(key.split('_')[1]) + '/' + parseInt(key.split('_')[0]),
                precipitacion: Math.round(this.props.historico[key]['precip']*100)/100,
                humedad: Math.round(this.props.historico[key]['H_media']*100)/100,
                temperatura: Math.round(this.props.historico[key]['T_media']*100)/100
            })
        }
        return (
            <div
                style={{
                    display: "flex",
                    flexDirection: "column",
                    width: '100%',
                    height: 600
                }}
            >
                <link rel="stylesheet"
                      href="https://fonts.googleapis.com/css?family=Poppins"
                />

                <Typography
                    style={{
                        fontWeight: "bold",
                        fontSize: this.state.vertical && !resolucion_tablet()? 20 : 30,
                        fontFamily: "Poppins"
                    }}
                >
                    {this.state.text["39"]}
                </Typography>



                <Paper
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        width: '100%',
                        height: "100%",
                        borderRadius: 20
                    }}
                >

                    <div
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            width: '100%',
                            height: '100%',
                            marginTop: 40
                        }}
                    >

                        <ResponsiveContainer
                            width="100%"
                            height="50%"
                        >
                            <BarChart
                                data={data}
                                margin={{
                                    top: 0,
                                    right: 50,
                                    left: 50,
                                    bottom: 20,
                                }}
                            >
                                <CartesianGrid />
                                <Tooltip/>
                                <Bar
                                    dataKey="precipitacion"
                                    radius={50}
                                    barSize={30}
                                >
                                    {data.map((entry: any, index: number) => (
                                        <Cell
                                            key={`cell-${index}`}
                                            fill={'rgb(40,140,198)'}
                                        />
                                    ))}
                                </Bar>
                                <XAxis dataKey="name" angle={0} dy={5}/>
                                <YAxis label={{ value: this.state.text["40"], angle: -90, position: 'Left', fontSize: 20, dx:-40, fontFamily: "Poppins"}} />
                                <YAxis yAxisId="right" orientation="right" label={{ value: '', angle: -90, position: 'Rigth', fontSize: 20, dx: 40}} />
                                <Brush
                                    height={30}
                                    stroke="#4C494B"
                                    startIndex={data.length - 10}
                                    endIndex={data.length - 1}
                                    dataKey="name"
                                />
                            </BarChart>
                        </ResponsiveContainer>

                        <ResponsiveContainer
                            width="100%"
                            height="50%"
                        >
                            <LineChart
                                data={data}
                                margin={{
                                    top: 30,
                                    right: 50,
                                    left: 50,
                                    bottom: 20,
                                }}
                            >
                                <CartesianGrid />
                                <XAxis dataKey="name" angle={0} dy={5}/>
                                <YAxis yAxisId="left" label={{ value: this.state.text["41"], angle: -90, position: 'Left', fontSize: 20, dx:-40, fontFamily: "Poppins"}} />
                                <YAxis yAxisId="right" orientation="right" label={{ value: this.state.text["42"], angle: -90, position: 'Rigth', fontSize: 20, dx: 40, fontFamily: "Poppins"}} />
                                <Tooltip/>
                                <Line
                                    yAxisId="left"
                                    type="monotone"
                                    dataKey="temperatura"
                                    stroke="#C62828"
                                    strokeWidth={3}
                                />
                                <Line
                                    yAxisId="right"
                                    type="monotone"
                                    dataKey="humedad"
                                    stroke="#288CC6"
                                    strokeWidth={3}
                                />
                                <Brush
                                    height={30}
                                    stroke="#4C494B"
                                    startIndex={data.length - 10}
                                    endIndex={data.length - 1}
                                    dataKey="name"
                                />
                            </LineChart>
                        </ResponsiveContainer>
                    </div>

                    <div
                        style={{
                            width: '100%',
                            marginTop: 20,
                            marginLeft: 20,
                            marginRight: 20,
                            marginBottom: 10
                        }}
                    >
                        <Typography
                            style={{
                                fontSize: 13,
                                color: '#555',
                                width: '95%',
                                fontFamily: "Poppins"
                            }}
                        >
                            {this.props.parcelaProps.siar_id.length > 0 ?
                                this.state.text["43"] + <a target={'_blank'} href="https://eportal.mapa.gob.es//websiar/Inicio.aspx">SiAR</a>
                                :
                                this.state.text["43"] + <a target={'_blank'} href="https://www.visualcrossing.com/">Visual Crossing</a>
                            }
                        </Typography>
                    </div>
                </Paper>
            </div>
        )
    }
}

const mapStateToProps = (state: IStore) => ({
    historico: state.riego.historico,
    parcela: state.navegacion.parcela,
    parcelaProps: state.riego.parcela,
    idioma: state.config.idioma
});

const mapDispatchToProps = (dispatch: (action: actionTypes) => void) => ({
    setHistorico: (historico: Record<string, Record<string, number>>) => dispatch({type: "set-riego-historico", historico})
});

export default connect(mapStateToProps, mapDispatchToProps)(Historico);
